import React from 'react';
import { useTranslation } from 'react-i18next';
import { Users, ShoppingCart, DollarSign, TrendingUp } from 'lucide-react';
import {
  DashboardMockup as StyledMockup,
  MockupHeader,
  MockupContent,
  MockupStatsGrid,
  MockupCard,
  MockupCardIcon,
  MockupCardInfo,
  MockupCardValue,
  MockupCardLabel,
  MockupCardChange,
  MockupChart,
  MockupChartHeader,
  MockupChartBars,
  MockupBar
} from './styles';

const DashboardMockup: React.FC = () => {
  const { t } = useTranslation();

  return (
    <StyledMockup>
      <MockupHeader>
        <div className="dots">
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div className="title">{t('dashboard.title')}</div>
      </MockupHeader>

      <MockupContent>
        <MockupStatsGrid>
          <MockupCard>
            <MockupCardIcon><Users size={20} color="#ff4444" /></MockupCardIcon>
            <MockupCardInfo>
              <MockupCardValue>{t('dashboard.metrics.leads.value')}</MockupCardValue>
              <MockupCardLabel>{t('dashboard.metrics.leads.label')}</MockupCardLabel>
              <MockupCardChange>{t('dashboard.metrics.leads.change')}</MockupCardChange>
            </MockupCardInfo>
          </MockupCard>

          <MockupCard>
            <MockupCardIcon><ShoppingCart size={20} color="#ff4444" /></MockupCardIcon>
            <MockupCardInfo>
              <MockupCardValue>{t('dashboard.metrics.sales.value')}</MockupCardValue>
              <MockupCardLabel>{t('dashboard.metrics.sales.label')}</MockupCardLabel>
              <MockupCardChange>{t('dashboard.metrics.sales.change')}</MockupCardChange>
            </MockupCardInfo>
          </MockupCard>

          <MockupCard>
            <MockupCardIcon><DollarSign size={20} color="#ff4444" /></MockupCardIcon>
            <MockupCardInfo>
              <MockupCardValue>{t('dashboard.metrics.revenue.value')}</MockupCardValue>
              <MockupCardLabel>{t('dashboard.metrics.revenue.label')}</MockupCardLabel>
              <MockupCardChange>{t('dashboard.metrics.revenue.change')}</MockupCardChange>
            </MockupCardInfo>
          </MockupCard>

          <MockupCard>
            <MockupCardIcon><TrendingUp size={20} color="#ff4444" /></MockupCardIcon>
            <MockupCardInfo>
              <MockupCardValue>{t('dashboard.metrics.conversion.value')}</MockupCardValue>
              <MockupCardLabel>{t('dashboard.metrics.conversion.label')}</MockupCardLabel>
              <MockupCardChange>{t('dashboard.metrics.conversion.change')}</MockupCardChange>
            </MockupCardInfo>
          </MockupCard>
        </MockupStatsGrid>

        <MockupChart>
          <MockupChartHeader>{t('dashboard.chart')}</MockupChartHeader>
          <MockupChartBars>
            <MockupBar height="40%"></MockupBar>
            <MockupBar height="65%"></MockupBar>
            <MockupBar height="30%"></MockupBar>
            <MockupBar height="80%"></MockupBar>
            <MockupBar height="55%"></MockupBar>
            <MockupBar height="90%"></MockupBar>
            <MockupBar height="45%"></MockupBar>
          </MockupChartBars>
        </MockupChart>
      </MockupContent>
    </StyledMockup>
  );
};

export default DashboardMockup;
